import { InformationalBanner, WidgetSizeEnum } from '@wonderschool/common-base-ui';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';

export function InvoiceDetailProcessingFeesPaidByFamilyDisclaimer({ organization, selectedInvoice }) {
  const { paymentsAreProcessingFeesHiddenWhenFamilyIsThePayerNotificationBannerEnabled } = useFlags();
  const { t } = useTranslation();

  const isFamilyPayingForProcessingFees = organization?.monetization?.payer === 'family';
  // if an invoice has processing fees paid by family, we need to show the disclaimer no matter the current organization configuration
  const hasProcessingFees = selectedInvoice.invoiceItemList.some((item) => item.processingFees !== undefined);
  if (!paymentsAreProcessingFeesHiddenWhenFamilyIsThePayerNotificationBannerEnabled) return null;

  return (
    (isFamilyPayingForProcessingFees || hasProcessingFees) && (
      <div>
        <InformationalBanner
          label={t('billing.invoiceDetails.processingFeesDisclamerWhenFamilyIsThePayer')}
          type="info"
          size={WidgetSizeEnum.SMALL}
          extraClasses="text-sm"
        />
      </div>
    )
  );
}
